import React, { useState, useEffect } from 'react';
// Components
import { FieldContainer, Field, Label, CharacterCounter } from '../field';
import { Helper } from '../Helper';
import calculateNodeHeight from './calculateNodeHeight';
// Hooks
import { useFieldValidation } from '../../hooks/validation-field';
import { handleValidateFormCharacter } from '../../hooks/validate-form-characters';
// Styles
import { CustomSup, TextareaField } from './mixins';
export const Textarea = ({ value, placeholder = '...', name, id, maxLength, onChange, onFocus, onBlur, disabled, rules, errors, fieldOptions, noBottomMargin, }) => {
    const { fieldStates, classes, setValue, setActive } = useFieldValidation(rules, errors, name, disabled);
    const { allowOnlyText = false } = fieldOptions || {};
    const [numCharacters, setNumCharacters] = useState(value ? value.toString().length : 0);
    const [height, setHeight] = useState(0);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [filteredValue, setFilteredValue] = useState(value);
    // Mantenemos actualizado el numero que mostramos en cantidad de caracteres
    useEffect(() => {
        setNumCharacters((filteredValue === null || filteredValue === void 0 ? void 0 : filteredValue.toString().length) || 0);
    }, [filteredValue]);
    const handleOnChange = (event, callback) => {
        const { value } = event.target;
        const currentFilteredValue = allowOnlyText ? handleValidateFormCharacter({ fieldValue: value }) : value;
        setFilteredValue(currentFilteredValue);
        setValue(currentFilteredValue);
        event.target.value = currentFilteredValue;
        callback && callback(event);
    };
    const handleOnBlur = (event, callback) => {
        setActive(false);
        callback && callback(event);
    };
    const handleOnFocus = (event, callback) => {
        setActive(true);
        callback && callback(event);
    };
    const handleResize = (event) => {
        const height = calculateNodeHeight(event.target, event.target.value);
        setHeight(height);
    };
    return (React.createElement(FieldContainer, null,
        fieldOptions && fieldOptions.label && (React.createElement(Label, { htmlFor: id || `textarea-${name}` },
            fieldOptions.label,
            rules && rules.required && React.createElement(CustomSup, null, "*"))),
        React.createElement(Field, Object.assign({}, fieldOptions, { states: Object.assign({}, fieldStates), className: classes }),
            React.createElement(TextareaField, Object.assign({ style: { height: `${height}px` }, name: name, id: id || `textarea-${name}`, placeholder: placeholder, disabled: disabled, maxLength: maxLength, value: filteredValue, autoCorrect: "off", autoCapitalize: "off", autoComplete: "off", spellcheck: "false", onChange: (event) => handleOnChange(event, onChange), onInput: (event) => handleResize(event), onPaste: (event) => handleResize(event), onCut: (event) => handleResize(event), onFocus: (event) => handleOnFocus(event, onFocus), onBlur: (event) => handleOnBlur(event, onBlur) }, fieldOptions, { ref: rules })),
            maxLength && (React.createElement(CharacterCounter, { errors: errors && errors[name] },
                numCharacters,
                " / ",
                maxLength))),
        React.createElement(Helper, { name: name, fieldOptions: fieldOptions, errors: errors, noBottomMargin: noBottomMargin })));
};
